import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import React from 'react';
import PropTypes from 'prop-types';
import { clickEvents } from '../../../../utils/analytics';

const SocialLinks = ({ profile }) => {

  const triggerAnalyticsEvent = (socialNetwork, slmCandidateID) => {
    clickEvents.candidatePageInteraction('contact', socialNetwork, slmCandidateID);
  };

  const addHttpsToUrls = (url) => {
    if (/^(?:(?!https{0,1}:\/\/)).*/i.test(url)) {
      return `https://${url}`;
    }
    return url;
  };

  return (
    <div style={{ marginTop: '10px' }}>
      {profile.facebookProfile && (
        <a
          aria-label="facebook"
          rel="noopener noreferrer"
          target="_blank"
          href={addHttpsToUrls(profile.facebookProfile)}
          onClick={() => {
            triggerAnalyticsEvent('facebook', profile.candidateId);
          }}
        >
          <FacebookIcon style={{ fill: '#3B5998', fontSize: 50 }} />
        </a>
      )}
      {profile.instagramProfile && (
        <a
          aria-label="instagram"
          target="_blank"
          rel="noopener noreferrer"
          href={addHttpsToUrls(profile.instagramProfile)}
          onClick={() => {
            triggerAnalyticsEvent('instagram', profile.candidateId);
          }}
        >
          <InstagramIcon style={{ fill: '#BC1888', fontSize: 50 }} />
        </a>
      )}
      {profile.linkedinProfile && (
        <a
          aria-label="linkedIn"
          target="_blank"
          rel="noopener noreferrer"
          href={addHttpsToUrls(profile.linkedinProfile)}
          onClick={() => {
            triggerAnalyticsEvent('linkedin', profile.candidateId);
          }}
        >
          <LinkedInIcon style={{ fill: '#0E76A8', fontSize: 50 }} />
        </a>
      )}
      {profile.youtubeProfile && (
        <a
          aria-label="youtube"
          target="_blank"
          rel="noopener noreferrer"
          href={addHttpsToUrls(profile.youtubeProfile)}
          onClick={() => {
            triggerAnalyticsEvent('youtube', profile.candidateId);
          }}
        >
          <YouTubeIcon style={{ fill: '#ff0000', fontSize: 50 }} />
        </a>
      )}
    </div>
  );
};

SocialLinks.propTypes = {
  profile: PropTypes.shape({
    candidateId: PropTypes.number,
    facebookProfile: PropTypes.string,
    instagramProfile: PropTypes.string,
    linkedinProfile: PropTypes.string,
    youtubeProfile: PropTypes.string
  }).isRequired
};

export default SocialLinks;
